import { render, staticRenderFns } from "./AddDistrictTypePage.vue?vue&type=template&id=ac199580&"
import script from "./AddDistrictTypePage.vue?vue&type=script&lang=js&"
export * from "./AddDistrictTypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports